import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useMinerLogs = () => {
  const logs = useSelector((state: RootState) => state.minerChangeLogs.logs);

  return logs;
};
